import { useSelector, useDispatch } from 'react-redux';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon.js';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage.js';
import useLocalStore from '../../../hooks/useLocalStore.js';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';
import FJImageInput from '../../../common/components/FJImageInput/FJImageInput.jsx';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData.js';

const FJImageInputContainer = ({ id }) => {
    useLocalStore();
    const uploadImageInfo = useSelector(state => state.imageToImage.uploadImageInfo);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);

    const dispatch = useDispatch();

    const uploadImg = file => {
        dispatch(FJActionImageToImage.uploadImageAction(file));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJImageInput
            uploadImageInfo={uploadImageInfo}
            isDraggingFile={isDraggingFile}
            openMediaLibrary={_openMediaLibrary}
            uploadImg={uploadImg}
            acceptFile={UPLOAD_FILE_TYPE_NO_GIF}
            setIsDraggingFile={_setIsDraggingFile}
            style={{
                height: '60px',
                flex: 'none',
                marginBottom: '20px',
            }}
            id={id}
        />
    );
};
export default FJImageInputContainer;
